module.exports = __webpack_public_path__ + "static/media/landlord.8c2ba327.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/landlord.svg
// module id = 2788
// module chunks = 0